export class PartyRole {
  partyRoleId: number;
  name: string;
}
